<div class="flex flex-col font-serif p-4 pt-8 md:p-8">
  <img
    src="/assets/img/logo_trimmed.png"
    class="max-w-[4rem] m-auto mb-4 absolute left-4 md:left-8 top-24 md:top-36 -rotate-12 z-100 scale-[.8] md:scale-[1]"
    alt=""
  />
  <h1
    class="mb-8 !font-bold capitalize !text-2xl md:!text-3xl !leading-tight !font-serif"
  >
    <span class="md:block">Your personal finance</span> has never been
    <span class="italic">this</span>
    organised
  </h1>
  <span class="text-lg mb-8"
    >Prefund is a budget manager application
    <span class="md:block"
      >made for people who like clarity and simplicity.</span
    ></span
  >
  <img
    src="/assets/img/prefund_hero_mini.jpg"
    alt=""
    class="mb-8 rounded-2xl border border-black"
  />
  <button
    mat-flat-button
    (click)="tryDemo()"
    class="mb-2 p-2 vertical-center !rounded-full capitalize block !bg-black !text-white font-sans"
  >
    <mat-icon class="align-middle">arrow_back</mat-icon> Try Prefund Demo
  </button>

  <!-- <button
    *ngIf="authService.isAuthenticationEnabled()"
    mat-flat-button
    (click)="onSignupClick.emit()"
    class="mb-2 p-2 vertical-center !rounded-full capitalize block !bg-black !text-white font-sans"
  >
    <mat-icon class="align-middle">person_add</mat-icon> Create A Free Account
  </button> -->

  <!-- <span class="text-center mb-4" *ngIf="authService.isAuthenticationEnabled()"
    >Already registered?
    <span class="underline cursor-pointer" (click)="onLoginClick.emit()"
      >Log in</span
    >.</span
  > -->
</div>
<div class="p-4 md:p-8">
  <cover-faq></cover-faq>
</div>

<!-- <div class="p-4 md:p-8"><cover-newsletter></cover-newsletter></div> -->

<div class="p-4 md:p-8 text-left">
  <h2 class="text-left font-serif !font-bold capitalize !text-2xl mb-2">
    About
  </h2>
  <div class="flex flex-col md:flex-row items-start">
    <div>
      <p class="mb-2">
        Hi! My name is Gábor. I'm a web developer and this is one of my personal projects.
      </p>
    </div>
    <div
      class="shrink-0 md:ml-4 mb-4 rounded-lg w-[80px] h-[80px] bg-[url('/assets/img/gabor2.jpg')] bg-cover bg-center rounded-full border border-black"
    ></div>
  </div>
</div>
